import { Button, Modal } from "antd";
import { useState } from "react";
import { MemberList } from "../../ComponentsCollapse/MemberCard/MemberPanel";
import { useSelector } from "../../../../../redux/store";
import { currentUserIsGameMasterSelector } from "../../../../../redux/selectors/currentUserIsGameMasterSelector";
import { membersSelector } from "../../../../../redux/selectors/membersSelector";

export const MemberButton = () => {
  const isGameMaster = useSelector(currentUserIsGameMasterSelector);
  const members = useSelector(membersSelector);

  const [showMemberModal, setShowMemberModal] = useState(false);
  return (
    <div
      style={{
        display: "block",
        top: 415,
        zIndex: 30,
        position: "absolute",
        transform: "rotate(270deg) translateY(-50px)",
      }}
    >
      <Modal
        destroyOnClose
        visible={showMemberModal}
        title={"Mitspieler"}
        onCancel={() => {
          setShowMemberModal(false);
        }}
        footer={null}
      >
        <MemberList members={members} isCurrentUserGameMaster={isGameMaster} />
      </Modal>
      <Button
        style={{ minWidth: 130 }}
        onClick={() => setShowMemberModal(true)}
        type={"primary"}
      >
        {members.length} Mitspieler 👩‍🚀
      </Button>
    </div>
  );
};
